import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'
import * as IoIcons from 'react-icons/io'

export const AsideData = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: 'dashboard',
        cName: 'nav-item'
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: 'person',
        cName: 'nav-item'
    },
    {
        title: 'Opportunities',
        path: '/opportunities',
        icon: 'table_view',
        cName: 'nav-item'
    },
    {
        title: 'Observations',
        path: '/observations',
        icon: 'view_in_ar',
        cName: 'nav-item'
    },
    {
        title: 'Notifications',
        path: '/notifications',
        icon: 'notifications',
        cName: 'nav-item'
    },
    {
        title: 'Recommendations',
        path: '/recommendations',
        icon: <IoIcons.IoMdHelpCircle/>,
        cName: 'nav-item'
    },
    {
        title: 'Cards',
        path: '/cards',
        icon: <IoIcons.IoMdHelpCircle/>,
        cName: 'nav-item'
    },
    {
        title: 'Privacy',
        path: '/privacy',
        icon: 'lock',
        cName: 'nav-item'
    },
]

